/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type Status = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const Status = {
    NUMBER_1: 1 as Status,
    NUMBER_2: 2 as Status,
    NUMBER_3: 3 as Status,
    NUMBER_4: 4 as Status,
    NUMBER_5: 5 as Status,
    NUMBER_6: 6 as Status,
    NUMBER_7: 7 as Status
};
